import * as Sentry from '@sentry/react';

export const initSentry = () => {
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: `hagatna-admin@${import.meta.env.VITE_APP_VERSION ?? '1.0.0'}`,

    integrations: [
      // Traces every page navigation as a transaction
      Sentry.browserTracingIntegration(),
      // Records user session as video replay — watch exactly what happened before the crash
      Sentry.replayIntegration({
        maskAllText: false,      // show text (set true if users have sensitive data on screen)
        blockAllMedia: false,
        maskAllInputs: true,     // always hide input fields (passwords, etc.)
      }),
    ],

    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    // Replay 10% of sessions, but 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
};

// Call after user logs in to attach identity to every error
export const setSentryUser = (user) => {
  if (!user) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name,
    role: user.role,
  });
};
